/**
 * 背景类型
 */
export enum BackgroundType {
  COLOR = 'Color',
  IMAGE = 'Image',
  VIDEO = 'Video',
}
